// extracted by mini-css-extract-plugin
export default {"icon":"PokemonIcon_icon__xW2vC"};